import { render } from "./vue_leaflet.vue?vue&type=template&id=04675ba8"
import script from "./vue_leaflet.vue?vue&type=script&lang=js"
export * from "./vue_leaflet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__